import { MEDIA_QUERY_STATES } from '@constants/media-query';
import { useMedia } from '@tkww/orion-web-app-kernel';
import { useMemo } from 'react';

interface CarouselSize {
	maxSlideWidth: number;
	minSlideWidth: number;
}

const useCarouselSize = (): CarouselSize => {
	const isXxl = useMedia('(min-width: 1360px)');
	const isXl = useMedia('(min-width: 1192px)');
	const isLg = useMedia('(min-width: 1024px)');

	const screenSizes = [isXxl, isXl, isLg];
	const slideWidths = useMemo(() => {
		if (isXxl === MEDIA_QUERY_STATES.matched) {
			return { minSlideWidth: 1016, maxSlideWidth: 1016 };
		}

		if (isXl === MEDIA_QUERY_STATES.matched) {
			return { minSlideWidth: 766, maxSlideWidth: 766 };
		}

		if (isLg === MEDIA_QUERY_STATES.matched) {
			return { minSlideWidth: 601, maxSlideWidth: 601 };
		}

		return { minSlideWidth: 560, maxSlideWidth: 560 };
	}, screenSizes);

	return slideWidths;
};

export default useCarouselSize;
